import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  folderId: string,
};

export class ApiPrintFavoriteProductListGet extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      ..._param
    } = param;

    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/favProduct`,
      'JSON',
      _param,
    );
  }
}
